import React, { useEffect, useState } from 'react';
import { getRegistrations } from './adminApi';
import './Admin.css';

const formatSlotDate = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleDateString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    });
};

const formatSlotTime = (isoString) => {
    const date = new Date(isoString);
    return date.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
};

export default function Registrations() {
    const [registrations, setRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');

    const load = () => {
        setLoading(true);
        getRegistrations({
            from: dateFrom || undefined,
            to: dateTo || undefined,
        })
            .then((data) => setRegistrations(data.registrations || []))
            .catch((e) => {
                console.error(e);
                alert(e.message || 'Ошибка загрузки');
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        load();
    }, [dateFrom, dateTo]);

    const clearFilters = () => {
        setDateFrom('');
        setDateTo('');
    };

    return (
        <div>
            <h3 style={{ marginTop: 0 }}>Записавшиеся пользователи</h3>

            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 16,
                    flexWrap: 'wrap',
                    marginBottom: 20,
                }}
            >
                <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>От:</span>
                    <input
                        type="date"
                        value={dateFrom}
                        onChange={(e) => setDateFrom(e.target.value)}
                        style={{ padding: '4px 8px' }}
                    />
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>До:</span>
                    <input
                        type="date"
                        value={dateTo}
                        onChange={(e) => setDateTo(e.target.value)}
                        style={{ padding: '4px 8px' }}
                    />
                </label>
                {(dateFrom || dateTo) && (
                    <button type="button" className="btn_admin" onClick={clearFilters}>
                        Сбросить
                    </button>
                )}
                <span style={{ color: '#666', fontSize: 14 }}>
                    {loading ? 'Загрузка…' : `Всего: ${registrations.length}`}
                </span>
            </div>

            <div style={{ overflowX: 'auto' }}>
                <table
                    style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        fontSize: 14,
                    }}
                >
                    <thead>
                        <tr style={{ backgroundColor: '#f0f0f0', textAlign: 'left' }}>
                            <th style={{ padding: '10px 12px', borderBottom: '2px solid #ccc' }}>Имя</th>
                            <th style={{ padding: '10px 12px', borderBottom: '2px solid #ccc' }}>Почта</th>
                            <th style={{ padding: '10px 12px', borderBottom: '2px solid #ccc' }}>Дата слота</th>
                            <th style={{ padding: '10px 12px', borderBottom: '2px solid #ccc' }}>Время</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!loading && registrations.length === 0 && (
                            <tr>
                                <td colSpan={4} style={{ padding: 16, color: '#666', textAlign: 'center' }}>
                                    Нет записей за выбранный период
                                </td>
                            </tr>
                        )}
                        {registrations.map((row) => (
                            <tr key={row.anketa_id} style={{ borderBottom: '1px solid #eee' }}>
                                <td style={{ padding: '10px 12px' }}>
                                    {row.fullName || row.user_name || '(без имени)'}
                                </td>
                                <td style={{ padding: '10px 12px' }}>{row.email}</td>
                                <td style={{ padding: '10px 12px' }}>{formatSlotDate(row.slot_datetime)}</td>
                                <td style={{ padding: '10px 12px' }}>{formatSlotTime(row.slot_datetime)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
